import Vue from "vue";
window.Vue = require("vue");
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
} catch (e) { }

import "bootstrap/dist/css/bootstrap.min.css";

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Content-Type"] = "application/json";
window.axios.defaults.headers.common["Accept"] = "application/json";

const token = localStorage.getItem("user-token");
if (token) {
    window.axios.defaults.headers.common["Authorization"] = token;
}

window.events = new Vue();
window.flash = function (message, level = "success") {
    window.events.$emit("flash", { message, level });
};

import VModal from "vue-js-modal";
Vue.use(VModal);

import Croppa from "vue-croppa";
Vue.use(Croppa);
import "vue-croppa/dist/vue-croppa.css";

import VueFlashMessage from "vue-flash-message";
Vue.use(VueFlashMessage, {
    messageOptions: {
        timeout: 5000,
        important: true,
        autoEmit: true,
        pauseOnInteract: true,
    },
});
require("vue-flash-message/dist/vue-flash-message.min.css");
